import api from "./api";
class CustomersService {
  async create(data) {
    return api
      .post("/customers/create", data)
      .then((response) => {
        return response;
      });
  }
  async getDataPage(params){
    return await this.getCustomers(params)
  }
  async importCustomers(formData){
    return api
    .post("/customers/import",formData,
        {
          headers: {
           'Content-Type': 'multipart/form-data',
       }
        })
    .then((response) => {
      return response;
    });
  }

  async updateById(id,data){
    return api
    .put("/customers/"+id,data)
    .then((response) => {
      return response;
    });
  }
 
  async getCustomerById(id){
    return api
    .get("/customers/"+id)
    .then((response) => {
      return response;
    });
  }
  async getCustomers(params)  {
    return api
    .get("/customers",{params:params})
    .then((response) => {
      return response;
    });
  }
  async getAllCompany()  {
    
    return api
    .get("/customers",{params:{company:1}})
    .then((response) => {
      return response;
    });
  }
  async getAllCustomers()  {
    return api
    .get("/customers")
    .then((response) => {
      return response;
    });
  }

  
}

export default new CustomersService();
